var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extras.groupNewsDisplay && _vm.extras.groupNewsDisplay.display === 1)?_c('div',{staticClass:"m-journalism top-nav new",style:({
    background:
      _vm.extras.newsBg.colorOrBg == 'color'
        ? _vm.extras.newsBg.color
        : 'url(' + _vm.extras.newsBg.src + ')',
  }),attrs:{"id":"news"}},[(_vm.extras.newsTitle.display === 1)?_c('WapTitle',{attrs:{"title":_vm.extras.newsTitle.mainTitle || _vm.title,"en":_vm.extras.newsTitle.subTitle || 'News',"extras":_vm.extras}}):_vm._e(),(_vm.columns.length > 1 || (_vm.columns.length == 1 && _vm.columns[0].id != 0))?_c('div',{staticClass:"m-tab-list-new-wap",class:'tab-length' + _vm.columns.length},_vm._l((_vm.columns),function(item,index){return _c('div',{key:index,staticClass:"tab-new",class:{
        active: item.id == _vm.currentId,
      },on:{"click":function($event){return _vm.columnClick(item)}}},[_vm._v(" "+_vm._s(item.name)+" "),_c('div',{staticClass:"underline",attrs:{"data-v-2a8f24dd":""}})])}),0):_vm._e(),(_vm.articles && _vm.articles.length > 0)?_c('div',{staticClass:"g-news-list-new-wap",class:_vm.extras.newsStyle.style == '1' ? 'single-line' : ''},_vm._l((_vm.articles),function(item,i){return _c('div',{key:i,staticClass:"item",style:({
        background:
          _vm.extras.newsItemBg.colorOrBg == 'color'
            ? _vm.extras.newsItemBg.color
            : 'url(' + _vm.extras.newsItemBg.src + ')',
      })},[_c('div',{staticClass:"date"},[(_vm.extras.newsDay.display == 1)?_c('div',{staticClass:"day",style:({
            color:
              _vm.extras.newsDay.text == 'custom' ? _vm.extras.newsDay.fontColor : '',

            'font-style':
              _vm.extras.newsDay.text == 'custom'
                ? _vm.extras.newsDay.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras.newsDay.text == 'custom'
                ? _vm.extras.newsDay.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          })},[_vm._v(" "+_vm._s(item.pushTime ? item.pushTime.substr(5, 5) : "")+" ")]):_vm._e(),(_vm.extras.newsYear.display == 1)?_c('div',{staticClass:"year",style:({
            color:
              _vm.extras.newsYear.text == 'custom'
                ? _vm.extras.newsYear.fontColor
                : '',

            'font-style':
              _vm.extras.newsYear.text == 'custom'
                ? _vm.extras.newsYear.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras.newsYear.text == 'custom'
                ? _vm.extras.newsYear.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          })},[_vm._v(" "+_vm._s(item.pushTime ? item.pushTime.substr(0, 4) : "")+" ")]):_vm._e()]),_c('div',{staticClass:"info"},[(_vm.extras.newsTitleStyle.display == 1 && item.useLinkUrl == 1)?_c('a',{staticClass:"title",style:({
            color:
              _vm.extras.newsTitleStyle.text == 'custom'
                ? _vm.extras.newsTitleStyle.fontColor
                : '',

            'font-style':
              _vm.extras.newsTitleStyle.text == 'custom'
                ? _vm.extras.newsTitleStyle.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras.newsTitleStyle.text == 'custom'
                ? _vm.extras.newsTitleStyle.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          }),attrs:{"target":"_blank","href":item.linkUrl}},[_vm._v(_vm._s(item.name))]):_vm._e(),(_vm.extras.newsTitleStyle.display == 1 && item.useLinkUrl != 1)?_c('a',{staticClass:"title",style:({
            color:
              _vm.extras.newsTitleStyle.text == 'custom'
                ? _vm.extras.newsTitleStyle.fontColor
                : '',

            'font-style':
              _vm.extras.newsTitleStyle.text == 'custom'
                ? _vm.extras.newsTitleStyle.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras.newsTitleStyle.text == 'custom'
                ? _vm.extras.newsTitleStyle.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          }),attrs:{"target":"_blank","href":item.shortUrl}},[_vm._v(_vm._s(item.name))]):_vm._e(),(_vm.extras.newsDesc.display == 1)?_c('div',{staticClass:"desc",style:({
            color:
              _vm.extras.newsDesc.text == 'custom'
                ? _vm.extras.newsDesc.fontColor
                : '',
            'font-style':
              _vm.extras.newsDesc.text == 'custom'
                ? _vm.extras.newsDesc.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras.newsDesc.text == 'custom'
                ? _vm.extras.newsDesc.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          })},[_vm._v(" "+_vm._s(item.desc)+" ")]):_vm._e()])])}),0):_vm._e(),(_vm.articles.length == 0)?_c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":require('@/assets/images/nodata.png')}}),_c('div',{staticClass:"no-data-text"},[_vm._v(_vm._s(_vm.$t("暂无数据")))])]):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }